import { useQuery } from '@tanstack/solid-query'
import { getServiceClient } from '~/lib/api'
import { inStep } from '~/lib/load-failure'
import { isInSubscription, type ServiceLevelStatus } from '~/lib/service-level'

export { isInSubscription, type ServiceLevelStatus }

export const serviceLevelKey = ['service-level-status'] as const

export function useServiceLevelStatusQuery() {
  return useQuery(() => ({
    queryKey: serviceLevelKey,
    queryFn: () =>
      inStep('load_service_level', async () => {
        const { client, userId } = await getServiceClient()
        return await client
          .get(`user/users/${userId}/service-levels/status`)
          .json<ServiceLevelStatus>()
      }),
  }))
}
